<script lang="ts">
  let { size = 28 }: { size?: number } = $props();
</script>

<!-- Книга заклинаний со знаком-галочкой (рендер — tools/icons), здесь лёгкий PNG 64 px. -->
<img class="logo" src="logo-64.png" width={size} height={size} alt="" aria-hidden="true" />

<style>
  .logo {
    display: block;
    border-radius: 7px;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 35%);
  }
</style>
